import { inject, Injectable } from '@angular/core';
import { UserIdleService } from 'angular-user-idle';
import { Subject, takeUntil } from 'rxjs';
import { LoginService } from 'src/app/main/login/login.service';

@Injectable({
    providedIn: 'root'
})
export class IdleSessionService {
    private readonly userIdle = inject(UserIdleService);
    private readonly loginService = inject(LoginService);
    private readonly destroy$ = new Subject<void>();

    startMonitoring(): void {
        // Start watching for user inactivity
        this.userIdle.startWatching();

        // Start watching when user idle is starting
        this.userIdle.onTimerStart().pipe(takeUntil(this.destroy$)).subscribe();

        // Logout user when idle timeout occurs
        this.userIdle.onTimeout().pipe(takeUntil(this.destroy$)).subscribe(async () => {
            await this.loginService.logout();
            this.userIdle.stopWatching();
        });
    }

    stopMonitoring(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.userIdle.stopWatching();
    }
}
